<template>
  <div class="wrapperPage pt-8" v-if="formData">
    <div
      class="sm:pl-0 container flex flex-col items-center sm:flex-row sm:justify-between"
    ></div>
    <div class="container">
      <div class="logo w-full p-1 flex justify-center sm:justify-start">
        <img class="" :src="logo" width="200" />
      </div>
      <vx-card class="mt-5">
        <table class="no-page-break table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="4">
              <div class="flex">
                DADOS PESSOAIS
                <div class="pl-3">
                  <b>Código</b>:
                  {{
                    formData.dadosCliente.idProspect
                      ? formData.dadosCliente.idProspect
                      : ''
                  }}
                </div>
              </div>
            </th>
          </tr>
          <tr>
            <td>
              <b>Nome</b>:
              {{ formData.dadosCliente ? formData.dadosCliente.nome : '' }}
            </td>
            <td>
              <b>CPF / CNPJ</b>:
              {{
                formData.dadosCliente.cpfcnpj
                  ? formData.dadosCliente.cpfcnpj
                  : ''
              }}
            </td>
          </tr>
          <tr>
            <td>
              <b>E-mail</b>:
              {{
                formData.dadosCliente.email ? formData.dadosCliente.email : ''
              }}
            </td>
            <td>
              <b>RG</b>:
              {{
                formData.dadosCliente.rg_ie ? formData.dadosCliente.rg_ie : ''
              }}
            </td>
          </tr>
          <tr>
            <td>
              <b>Telefone</b>:
              {{
                formData.dadosCliente.telefone
                  ? formData.dadosCliente.telefone
                  : ''
              }}
            </td>
            <td>
              <b>Celular</b>:
              {{
                formData.dadosCliente.celular
                  ? formData.dadosCliente.celular
                  : ''
              }}
            </td>
          </tr>
          <tr>
            <td>
              <b>Status</b>:
              {{
                formData.dadosCliente.status ? formData.dadosCliente.status : ''
              }}
            </td>
            <td>
              <b>Data de cadastro</b>:
              {{
                formData.dadosCliente.dataCadastro
                  ? formataData(formData.dadosCliente.dataCadastro, 'withHour')
                  : ''
              }}
            </td>
          </tr>
          <tr>
            <td>
              <b>Boletos em aberto</b>:
              {{
                formData.dadosCliente.boletosEmAberto
                  ? formData.dadosCliente.boletosEmAberto
                  : ''
              }}
            </td>
            <td>
              <b>Consultor</b>:
              {{
                formData.dadosCliente.consultor
                  ? formData.dadosCliente.consultor
                  : ''
              }}
            </td>
          </tr>
          <tr>
            <td>
              <b>{{ $t('Regional') }}</b
              >:
              {{
                formData.dadosCliente.regional
                  ? formData.dadosCliente.regional
                  : ''
              }}
            </td>
            <td>
              <b>{{ $t('Divisão') }}</b
              >:
              {{
                formData.dadosCliente.divisao
                  ? formData.dadosCliente.divisao
                  : ''
              }}
            </td>
          </tr>
        </table>
      </vx-card>

      <vx-card class="mt-3">
        <table class="no-page-break table">
          <tr class="title p-1 w-full">
            <th colspan="4">DADOS DO VEÍCULO</th>
          </tr>
          <tr>
            <td><b>Marca</b>: {{ formData.dadosVeiculo.veiculoMarca }}</td>
            <td><b>Modelo</b>: {{ formData.dadosVeiculo.veiculoModelo }}</td>
            <td>
              <b>Ano</b>: {{ formData.dadosVeiculo.anoFabricacao }}/
              {{ formData.dadosVeiculo.anoModelo }}
            </td>
          </tr>
          <tr>
            <td><b>Chassi</b>: {{ formData.dadosVeiculo.chassi }}</td>
            <td><b>Placa</b>: {{ formData.dadosVeiculo.placa }}</td>
            <td><b>Renavam</b>: {{ formData.dadosVeiculo.renavam }}</td>
          </tr>
          <tr>
            <td><b>Cor</b>: {{ formData.dadosVeiculo.cor }}</td>
            <td>
              <b>Status</b>:
              {{ formData.dadosVeiculo.status }}
            </td>
            <td><b>Código FIPE</b>: {{ formData.dadosVeiculo.codigoFipe }}</td>
          </tr>
          <tr>
            <td>
              <b>Data de Cadastro</b>:
              {{ formataData(formData.dadosVeiculo.dataCadastro) }}
            </td>
            <td>
              <b>Franquia</b>: {{ formData.dadosVeiculo.cotaParticipacao }}%
              FIPE, mínimo de
              {{ formData.dadosVeiculo.valorParticipacaoMinimo | currency }}
            </td>
            <td><b>Cambio</b>: {{ formData.dadosVeiculo.cambio }}</td>
          </tr>
        </table>
      </vx-card>

      <vx-card class="mt-3">
        <table class="table no-page-break">
          <tr class="title p-1 w-full">
            <th colspan="4">DADOS DO EVENTO</th>
          </tr>
          <tr>
            <td><b>Protocolo</b>: {{ formData.protocolo }}</td>
            <td>
              <b>Tipo do evento</b>:
              {{ formData.dadosGerais.descricaoTipoEvento }}
            </td>
          </tr>
          <tr>
            <td>
              <b>Data do evento</b>: {{ formData.dadosGerais.dataEvento }}
              {{ formData.dadosEventos.horaEvento }}
            </td>
            <td>
              <b>Data de abertura do evento</b>:
              {{ formData.createdAt | formatDate }}
            </td>
          </tr>

          <tr>
            <td>
              <b>Envolvimento</b>:
              {{ formData.dadosGerais.descricaoEnvolvimento }}
            </td>
            <td>
              <b>Número do boletim</b>: {{ formData.dadosGerais.numeroBoletim }}
            </td>
          </tr>

          <tr>
            <td>
              <b>Dia da semana</b>:
              {{ diaSemana }}
            </td>
            <td>
              <b>Data do primeiro E-mail</b>:
              {{ formData.dadosEventos.primeiroEmail }}
            </td>
          </tr>

          <tr>
            <td>
              <b>Local do acidente sinalizado?</b>:
              {{ labelBoolean(formData.enderecoEvento.localSinalizado) }}
            </td>

            <td>
              <b>Sinalização do local do acidente</b>:
              {{
                formData.enderecoEvento.sinalizacao
                  ? formData.enderecoEvento.sinalizacao
                  : ''
              }}
            </td>
          </tr>

          <tr>
            <td class="px-3" colspan="2">
              <b>Endereço do evento</b>:
              {{ formData.enderecoEvento ? formData.enderecoEvento.cep : '' }}
              -
              {{
                formData.enderecoEvento ? formData.enderecoEvento.endereco : ''
              }}
              {{
                formData.enderecoEvento ? formData.enderecoEvento.numero : ''
              }}
              {{
                formData.enderecoEvento
                  ? formData.enderecoEvento.complemento
                  : ''
              }}
              -
              {{
                formData.enderecoEvento ? formData.enderecoEvento.bairro : ''
              }}
              -
              {{
                formData.enderecoEvento ? formData.enderecoEvento.cidade : ''
              }}
              /
              {{
                formData.enderecoEvento ? formData.enderecoEvento.estado : ''
              }}
            </td>
          </tr>

          <tr>
            <td class="px-3" colspan="2">
              <b>Observação sobre o local</b>:
              {{
                formData.enderecoEvento.observacaoLocal
                  ? formData.enderecoEvento.observacaoLocal
                  : ''
              }}
            </td>
          </tr>
        </table>
      </vx-card>

      <vx-card
        v-if="formData.dadosAnalise && formData.dadosAnalise.analise"
        class="mt-3"
      >
        <table class="no-page-break">
          <tr>
            <td>
              <b>Ressarcimento</b>:
              {{ labelBoolean(formData.dadosAnalise.analise.ressarcimento) }}
            </td>
            <td>
              <b>Passível de Negativa</b>:
              {{ labelBoolean(formData.dadosAnalise.analise.passivelNegativa) }}
            </td>
            <td>
              <b>EAR</b>:
              {{ labelBoolean(formData.dadosAnalise.analise.ear) }}
            </td>
            <td>
              <b>Atendimento Benefíciario</b>:
              {{
                labelBoolean(formData.dadosAnalise.analise.atendimentoAssociado)
              }}
            </td>
            <td>
              <b>Possui Tacógrafo</b>:
              {{ labelBoolean(formData.dadosAnalise.analise.posuiTacografo) }}
            </td>
          </tr>
          <tr>
            <td>
              <b>Possui Rastreador</b>:
              {{ labelBoolean(formData.dadosAnalise.analise.rastreador) }}
            </td>
            <td>
              <b>Contato com Assistência?</b>:
              {{ labelBoolean(formData.dadosAnalise.contatoAssistencia) }}
            </td>
            <td>
              <b>CNH Vencida</b>:
              {{ labelBoolean(formData.dadosAnalise.analise.cnhVencida) }}
            </td>
            <td>
              <b>Atendimento Terceiro</b>:
              {{
                labelBoolean(formData.dadosAnalise.analise.atendimentoTerceiro)
              }}
            </td>
            <td>
              <b>Atendimento Somente Terceiro</b>:
              {{
                labelBoolean(
                  formData.dadosAnalise.analise.atendimentoSomenteTerceiro,
                )
              }}
            </td>
          </tr>
          <tr>
            <td colspan="3">
              <b>Data Vencimento CNH</b>:
              {{ formData.condutor.dadosPessoaisCondutor.dataVencimentoCnh }}
            </td>
            <td colspan="2">
              <b>Categoria da CNH</b>:
              <span
                v-for="(item, index) in formData.condutor.dadosPessoaisCondutor
                  .categoriaCnh"
                :key="index"
                >{{ item }},
              </span>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <b>Data/Hora Contato Assistência</b>:
              {{ formData.dadosAnalise.dataContatoAssistencia || '' }}
              {{ formData.dadosAnalise.horaContatoAssistencia || '' }}
            </td>
            <td colspan="3">
              <b>Analista Responsável - Análise</b>:
              {{ analistaSelecionado.id }} - {{ analistaSelecionado.label }}
            </td>
          </tr>
        </table>
      </vx-card>

      <vx-card v-if="arrayValido(formData.terceiros)" class="mt-3">
        <table class="table no-page-break">
          <tr class="title p-1 w-full">
            <th colspan="6">TERCEIROS</th>
          </tr>
          <tr>
            <th>Protocolo</th>
            <th>Nome</th>
            <th>Telefone</th>
            <th>Placa</th>
            <th>Marca</th>
            <th>Modelo</th>
          </tr>
          <tr v-for="(terceiro, index) in formData.terceiros" :key="index">
            <td>{{ terceiro.protocolo }}</td>
            <td>
              {{ terceiro.nome }}
            </td>
            <td>
              {{ terceiro.telefone }}
            </td>
            <td>
              {{ terceiro.placa }}
            </td>
            <td>
              {{ terceiro.veiculoMarca }}
            </td>
            <td>
              {{ terceiro.veiculoModelo }}
            </td>
          </tr>
        </table>
      </vx-card>

      <vx-card v-if="arrayValido(formData.listBoletos)" class="mt-3">
        <table class="table">
          <thead>
            <tr class="title p-1 w-full">
              <th colspan="11">ANÁLISE DE BOLETOS</th>
            </tr>
            <tr>
              <th>Placa</th>
              <th>Tipo</th>
              <th>Emissão</th>
              <th>Vencimento</th>
              <th>Data original</th>
              <th>Pagamento</th>
              <th>Valor</th>
              <th>Valor pago</th>
              <th>Situação</th>
              <th>Status</th>
              <th>Mês Referente</th>
            </tr>
          </thead>
          <body></body>
          <tr v-for="(boleto, index) in formData.listBoletos" :key="index">
            <td>
              {{ boleto.placa }}
            </td>
            <td>
              {{ boleto.tipoBoleto }}
            </td>
            <td>
              {{ boleto.data_emissao }}
            </td>
            <td>
              {{ boleto.data_vencimento }}
            </td>
            <td>
              {{ boleto.data_vencimento }}
            </td>
            <td>
              {{ boleto.data_vencimento_original }}
            </td>
            <td>
              {{ boleto.data_pagamento }}
            </td>
            <td>
              {{ boleto.valor_boleto }}
            </td>
            <td>
              {{ boleto.valor_pagamento }}
            </td>
            <td>
              {{ boleto.situacao }}
            </td>
            <td>
              {{ boleto.mes_referente }}
            </td>
          </tr>
        </table>
      </vx-card>

      <vx-card v-if="arrayValido(formData.listVeiculos)" class="mt-3">
        <table class="table no-page-break">
          <tr class="title p-1 w-full">
            <th colspan="7">VEÍCULOS NA BASE</th>
          </tr>
          <tr>
            <th>Status</th>
            <th>Placa</th>
            <th>Marca</th>
            <th>Modelo</th>
            <th>Ano</th>
            <th>Data de cadastro</th>
            <th>Franquia</th>
          </tr>
          <tr v-for="(veiculo, index) in formData.listVeiculos" :key="index">
            <td>
              {{ veiculo.dadosVeiculo.status }}
            </td>
            <td>
              {{ veiculo.dadosVeiculo.placa }}
            </td>
            <td>
              {{ veiculo.dadosVeiculo.veiculoMarca }}
            </td>
            <td>
              {{ veiculo.dadosVeiculo.veiculoModelo }}
            </td>
            <td>
              {{ veiculo.dadosVeiculo.anoFabricacao }}/{{
                veiculo.dadosVeiculo.anoModelo
              }}
            </td>
            <td>
              {{ formataData(veiculo.dadosVeiculo.dataCadastro) }}
            </td>
            <td>{{ veiculo.dadosVeiculo.cotaParticipacao }}%</td>
          </tr>
        </table>
      </vx-card>

      <vx-card v-if="arrayValido(formData.listProdutos)" class="mt-3">
        <table class="table no-page-break">
          <tr class="title p-1 w-full">
            <th colspan="7">PRODUTOS</th>
          </tr>
          <tr>
            <th>Nome Produto</th>
            <th>Tipo</th>
            <th>Valor Inicial</th>
            <th>Valor Desconto</th>
            <th>Valor Final</th>
            <th>Forma de Pagamento</th>
          </tr>
          <tr v-for="(produto, index) in formData.listProdutos" :key="index">
            <td>
              {{ produto.nomeProduto }}
            </td>
            <td>
              {{ produto.obrigatorio ? 'Obrigatório' : 'Opcional' }} -
              {{ produto.isMensal ? 'Mensal' : 'Entrada' }}
            </td>
            <td>
              <span
                v-if="produto.valor != produto.valorFinal"
                style="text-decoration: line-through"
              >
                {{ produto.valor | currency }}
              </span>
              <span v-else>
                {{ produto.valor | currency }}
              </span>
            </td>
            <td>
              {{ (produto.valor - produto.valorFinal) | currency }}
            </td>
            <td>
              <b>{{ produto.valorFinal | currency }}</b>
            </td>
            <td>
              {{ produto.nomePagamento }}
            </td>
          </tr>
        </table>
      </vx-card>

      <vx-card class="mt-3">
        <table class="table no-page-break">
          <tr class="title p-1 w-full">
            <th colspan="4">BOLETIM DE OCORRÊNCIA</th>
          </tr>
          <tr>
            <td colspan="2">
              <b>Data/Hora do registro BO</b>:
              {{ formData.boletimOcorrencia.dataBoletim }}
              {{ formData.boletimOcorrencia.horaBoletim }}
            </td>
            <td colspan="1">
              <b>Dias após o fato</b>:
              {{ qtdDiasPassados }}
            </td>
          </tr>

          <tr>
            <td>
              <b>Elaboração do BO Presencial?</b>:
              {{ labelBoolean(formData.boletimOcorrencia.boletimPresencial) }}
            </td>
            <td>
              <b>BO Online?</b>:
              {{ labelBoolean(formData.boletimOcorrencia.boletimOnline) }}
            </td>
            <td>
              <b>Houve vítima?</b>:
              {{ labelBoolean(formData.boletimOcorrencia.possuiVitima) }}
            </td>
            <td>
              <b>Monta</b>:
              {{ montaSelecionada(formData.boletimOcorrencia.idMonta) }}
            </td>
          </tr>

          <tr>
            <td colspan="4">
              <b>Relato do Boletim de Ocorrência</b>:
              {{ formData.boletimOcorrencia.descricaoBoletim || '' }}
            </td>
          </tr>
        </table>
      </vx-card>

      <vx-card v-if="arrayValido(formData.listFotosDocumentos)" class="mt-3">
        <ListImagensImpressao
          title="FOTOS DO VEÍCULO BENEFÍCIARIO"
          :imgs="formData.listFotosDocumentos"
        />
      </vx-card>

      <div v-if="arrayValido(formData.listFotosDocumentosTerceiros)">
        <div
          v-for="(
            imgsTerceiro, indexTerceiro
          ) in formData.listFotosDocumentosTerceiros"
          :key="indexTerceiro"
        >
          <vx-card class="mt-3">
            <ListImagensImpressao
              :title="`FOTOS DO VEÍCULO TERCEIRO: ${imgsTerceiro.nome}`"
              :imgs="imgsTerceiro.listFotosDocumentos"
            />
          </vx-card>
        </div>
      </div>

      <vx-card
        v-if="
          arrayValido(formData.imageCroqui) ||
          arrayValido(formData.listLocaislEvento)
        "
        class="mt-3"
      >
        <table class="table no-page-break">
          <tr class="title p-1 w-full">
            <th colspan="6">CROQUI DO EVENTO</th>
          </tr>
          <tr>
            <th>Local</th>
            <th>Usuário</th>
            <th>Data/Hora</th>
          </tr>
          <tr v-for="(local, index) in formData.listLocaislEvento" :key="index">
            <td v-html="local.local"></td>
            <td>
              {{ local.usuario }}
            </td>
            <td>
              {{ formataData(local.createdAt, 'withHour') }}
            </td>
          </tr>
        </table>
        <div class="flex justify-center">
          <img
            v-for="(imgCroqui, indexImg) in formData.imageCroqui"
            :key="indexImg"
            class="w-1/2"
            :src="imgCroqui.nome"
          />
        </div>
      </vx-card>

      <vx-card v-if="arrayValido(formData.listFotosCroqui)" class="mt-3">
        <ListImagensImpressao
          title="FOTOS ADICIONAIS CROQUI"
          :imgs="formData.listFotosCroqui"
        />
      </vx-card>

      <vx-card
        v-if="formData.dadosAnalise && formData.dadosAnalise.analise"
        class="my-3"
      >
        <table class="no-page-break">
          <tr class="title p-1 w-full">
            <th colspan="4">ANÁLISE TÉCNICA</th>
          </tr>
          <tr>
            <td>
              <b>Análise de vistoria Prévia</b>:
              {{ labelBoolean(formData.analiseTecnica.analiseVistoriaPrevia) }}
            </td>
            <td>
              <b>Evento Aprovado</b>:
              {{ labelBoolean(formData.analiseTecnica.eventoAprovado) }}
            </td>
            <td>
              <b>Perda Total</b>:
              {{ labelBoolean(formData.analiseTecnica.perdaTotal) }}
            </td>
            <td>
              <b>Sindicância</b>:
              {{ labelBoolean(formData.analiseTecnica.sindicancia) }}
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <b>Descrição do evento para controle interno/Terceiro coincidem</b
              >:
              {{
                labelBoolean(
                  formData.analiseTecnica.avisoAssociadoTerceiroConincidem,
                )
              }}
            </td>
            <td>
              <b>Terceiro informações diverventes</b>:
              {{
                labelBoolean(
                  formData.analiseTecnica.terceiroInformacoesDiverventes,
                )
              }}
            </td>
            <td>
              <b>Monta conforme análise</b>:
              {{ montaSelecionada(formData.analiseTecnica.idMonta) }}
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <b>Informações divergentes</b>:
              <div
                v-html="formData.analiseTecnica.informacoesDiverventes"
              ></div>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <b>Resumo do Analista</b>:
              <div v-html="formData.analiseTecnica.resumoAnalista"></div>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <b>Conclusão do Comitê</b>:
              <div v-html="formData.analiseTecnica.conclusaoComite"></div>
            </td>
          </tr>
        </table>
      </vx-card>
    </div>
    <vs-button
      radius
      @click="print"
      class="no-print pulse-button fixed bottom-0 right-0 mb-20 mr-20 p-5"
      ><vs-icon size="medium" icon="print" />
    </vs-button>
  </div>
</template>

<script>
import services from '../../services';
import notify from '../../utils/notify';
import dayjs from 'dayjs';
import dateConversion from '../../utils/dateConversion';
import serviceEventos from '../menu/eventos/shared/service';
import functions from '../../utils/functions';
import ListImagensImpressao from '../menu/eventos/shared/components/ListImagensImpressao.vue';

export default {
  components: { ListImagensImpressao },
  data() {
    return {
      isLoading: true,
      formData: {
        idEvento: null,
        protocolo: null,
        dadosCliente: {},
        dadosVeiculo: {},
        dadosGerais: {},
        dadosAnalise: {},
        condutor: {},
        terceiros: [],
        dadosEventos: {},
        enderecoEvento: {},
        novoLocalEvento: {},
        listLocaislEvento: [],
        boletimOcorrencia: {},
        listFotosDocumentos: [],
        listFotosCroqui: [],
        listFotosDocumentosTerceiros: null,
        analiseTecnica: {},
        listBoletos: [],
        listProdutos: [],
        listVeiculos: [],
      },
      diaSemana: null,
      dominios: {
        listUsuarios: [],
        listMonta: [],
      },
      analistaSelecionado: {
        id: null,
        label: 'Nenhum analista selecionado',
      },
      logo: null,
    };
  },
  computed: {
    qtdDiasPassados() {
      const dataHoraEvento = this.formData.dadosEventos.dataHoraEvento;
      const dataBoletim = this.formData.boletimOcorrencia.dataBoletim;
      const horaBoletim = this.formData.boletimOcorrencia.horaBoletim;
      if (!dataHoraEvento || !dataBoletim || !horaBoletim) {
        return '';
      }

      const auxDataHoraBoletim = `${dateConversion.convertDateToISO(
        dataBoletim,
      )} ${horaBoletim}`;

      const ms = dayjs(auxDataHoraBoletim).diff(dataHoraEvento);
      const qtdDias = functions.formataMsParaData(ms);

      return qtdDias;
    },
  },
  methods: {
    /**
     * Fetches data and updates the component state accordingly.
     * @async
     * @returns {Promise<void>} A Promise that resolves when data fetching is complete.
     */
    async buscaDados() {
      this.logo = localStorage.getItem('logo');
      const { chave } = this.$route.params;

      if (!chave) {
        return;
      }

      try {
        this.$vs.loading();

        const result = await services.getAll(
          'eventos2',
          null,
          `analise/${chave}`,
        );
        const evento = result.data;

        if (!evento) {
          notify.notifyFail(
            this.$vs,
            'Você não tem acesso a visualização deste Evento',
          );
          this.$vs.loading.close();
          return;
        }
        if (evento.dadosGerais.dataEvento) {
          this.diaSemana = dateConversion.diaDaSemana(
            evento.dadosGerais.dataEvento,
          );
        }
        this.isLoading = false;

        this.$nextTick(() => {
          this.formData = evento;
        });
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },

    /**
     * Fetches domain data needed for the component.
     * @async
     * @returns {Promise<void>} A Promise that resolves when domain data fetching is complete.
     */
    async getDominios() {
      try {
        this.$vs.loading();

        const promises = [
          serviceEventos.getListUsuarios(),
          serviceEventos.getListDominio('domEventosMonta', 'monta', 'idMonta'),
        ];

        const [listUsuarios, listMonta] = await Promise.all(promises);

        this.dominios.listUsuarios = listUsuarios;
        this.dominios.listMonta = listMonta;

        if (this.formData.dadosAnalise.analise.idUsuarioAnalise) {
          this.analistaSelecionado = listUsuarios.find(
            (usuario) =>
              usuario.id ===
              this.formData.dadosAnalise.analise.idUsuarioAnalise,
          );
        }
      } catch (error) {
        console.error(error);
        notify.notifyFail(this.$vs, 'Falha ao carregar os dados do evento');
      } finally {
        this.$vs.loading.close();
      }
    },

    /**
     * Formats a given date into a specific format.
     * @param {Date|string} data The date to be formatted.
     * @param {string} [extraParams=''] Additional parameters to determine the format. Possible value: 'withHour'.
     * @returns {string} The formatted date string.
     */
    formataData(data, extraParams = '') {
      if (!data) {
        return '';
      }
      const formato =
        extraParams === 'withHour' ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY';
      const dataFormatada = dayjs(data).format(formato);
      return dataFormatada;
    },

    /**
     * Checks if an array is valid, i.e., if it exists and contains elements.
     * @param {Array} arrayName The array to be validated.
     * @returns {boolean} True if the array is valid (exists and contains elements), otherwise false.
     */
    arrayValido(arrayName) {
      const existContent = arrayName && arrayName.length > 0;
      return existContent;
    },

    /**
     * Converts a boolean value into a corresponding label ('Sim' for true, 'Não' for false).
     * @param {boolean} value The boolean value to convert.
     * @returns {string} The label corresponding to the boolean value ('Sim' for true, 'Não' for false).
     */
    labelBoolean(value) {
      const simOuNao = value ? 'Sim' : 'Não';
      return simOuNao;
    },

    /**
     * Retrieves the label corresponding to the selected monta based on its ID.
     * @param {number} idMonta The ID of the selected monta.
     * @returns {string} The label of the selected monta, or 'Nenhuma opção selecionada' if no monta is selected or the list of montas is invalid.
     */
    montaSelecionada(idMonta) {
      if (idMonta && this.arrayValido(this.dominios.listMonta)) {
        const { label } = this.dominios.listMonta.find(
          (monta) => monta.id === idMonta,
        );
        return label;
      }
      return 'Nenhuma opção selecionada';
    },

    /**
     * Initiates the print dialog for the current window.
     */
    print() {
      window.print();
    },
  },
  async created() {
    await this.buscaDados();
    await this.getDominios();
  },
  mounted() {
    this.$i18n.locale = functions.setLocaleBasedOnCompany();
  },
};
</script>

<style>
@import url('https://fonts.cdnfonts.com/css/gotham');

.wrapperPage {
  font-family: 'regular', 'Gotham', sans-serif;
  text-rendering: optimizeLegibility !important;
  -webkit-font-smoothing: antialiased !important;
}

table {
  width: 100%;
  gap: 20px;
}

tr:nth-child(odd) {
  background-color: #edf4fb;
}

.title {
  background-color: #043562 !important;
  color: white;
}

.listItemsProtecoes {
  color: rgb(59, 59, 59);
  font-size: 0.9rem;
  font-weight: 600;
}

.A3 .sheet {
  width: 297mm;
  height: 419mm;
}
.A3.landscape .sheet {
  width: 420mm;
  height: 296mm;
}
.A4 .sheet {
  width: 210mm;
  height: 296mm;
}
.A4.landscape .sheet {
  width: 297mm;
  height: 209mm;
}
.A5 .sheet {
  width: 148mm;
  height: 209mm;
}
.A5.landscape .sheet {
  width: 210mm;
  height: 147mm;
}

/** Padding area **/
.sheet.padding-10mm {
  padding: 10mm;
}
.sheet.padding-15mm {
  padding: 15mm;
}
.sheet.padding-20mm {
  padding: 20mm;
}
.sheet.padding-25mm {
  padding: 25mm;
}

td {
  padding: 2px 5px;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.pulse-button {
  animation: pulse 1.5s infinite;
}

@media screen {
  body {
    background: #e0e0e0;
    display: flex;
    justify-content: center;
  }
  .sheet,
  .quebraPagina {
    background: white;
    box-shadow: 0 0.5mm 2mm rgba(0, 0, 0, 0.3);
    margin-top: 1em;
    margin-bottom: 1em;
  }
  .printer {
    display: none;
  }
}

@media print {
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .no-page-break {
    page-break-inside: avoid;
  }
  .container {
    max-width: 100%;
  }
  .vx-card .vx-card__collapsible-content .vx-card__body {
    padding: 2px;
  }
  .wrapperPage {
    padding: 0;
  }
  .no-print {
    display: none;
  }
  thead {
    display: table-header-group;
  }
}
</style>
